import {Flex, Text, VStack} from "@chakra-ui/react"
import SentimentBar from "./SentimentBar"

export default function SentimentBarGrid({
                                             series,
                                             categories,
                                             selectedAspect,
                                             handleClick,
                                             expandAspects,
                                             onExpandAspects,
                                             readerRef,
                                             handleScroll
                                         }) {
    const collapsedRows = 4;
    const rows = expandAspects ? series : series.slice(0, collapsedRows);
    console.log("Rows", rows);
    console.log("Categories", categories);

    const maxSum = series.length > 0 ? series[0][0]["data"][0] + series[0][1]["data"][0] + series[0][2]["data"][0] : 1
    console.log("maxSum", maxSum)
    return (
        <>
            <VStack overflowY="auto" maxHeight="450px" onScroll={handleScroll} ref={readerRef}>
                {rows.map((row, idx) => (
                    <Flex key={idx} align="flex-start" onClick={() => handleClick(categories[idx], "all")}
                          _hover={{cursor: "pointer", bgColor: "#EEEEEE"}}
                          bgColor={categories[idx] === selectedAspect ? "rgba(75, 124, 248, 0.25)" : null}>
                        <Flex justify={"flex-end"} w={"250px"} align="flex-end">
                            <Text fontSize="lg" mr="10px">{categories[idx]}</Text>
                        </Flex>
                        <SentimentBar series={row} maxWidth={500} maxSum={maxSum}/>
                    </Flex>
                ))}

            </VStack>
            <Text onClick={() => onExpandAspects()} _hover={{cursor: "pointer"}}
                  color="#4338DF" mx="auto">
                {expandAspects ? "Show Less" : "More Aspects"}</Text>
        </>
    )
}